export default {
    url: 'https://grammar.oss-cn-qingdao.aliyuncs.com/online/image/notework'
  }
  


// WEBPACK FOOTER //
// ./src/defaultSettings.js